// @ts-nocheck
import { useState, useRef } from 'react';
import { Dialog } from "primereact/dialog";
import { TabView, TabPanel } from 'primereact/tabview';
import { Toast } from 'primereact/toast';
import { Chart } from 'primereact/chart';
import { TerrainProfileComponents } from './AnalysisInfo/TerrainProfileComponents';
import { SliceSpaceComponents } from './AnalysisInfo/SliceSpaceComponents';
import { ViewshedAnalysisComponents } from './AnalysisInfo/ViewshedAnalysisComponents';
import "../assets/functionalComponents/_dialog.scss"
import "../assets/functionalComponents/_dataItem.scss"

export const AnalysisComponents = (props: { Analysis: any; onHide: (arg0: string) => any; }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [TerrainProfileOpen, setTerrainProfileOpen] = useState(false);
    const [TerrainProfileValue, setTerrainProfileValue] = useState({});
    const [isSliceSpace, setIsSliceSpace] = useState(false);
    const [ViewshedAnalysisSetting, setViewshedAnalysisSetting] = useState({
        color: "F17013",
        viewshedRange: 2000,
        posX: 120.973882,
        posY: 23.97565,
        posZ: 1000
    });
    const toast = useRef(null);

    const getLightTheme = () => {
        let basicOptions = {
            maintainAspectRatio: false,
            aspectRatio: .6,
            plugins: {
                legend: {
                    labels: {
                        color: '#495057'
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: '#495057',
                        display: false
                    },
                    grid: {
                        color: '#ebedef'
                    }
                },
                y: {
                    ticks: {
                        color: '#495057'
                    },
                    grid: {
                        color: '#ebedef'
                    }
                }
            }
        };

        return {
            basicOptions
        }
    }

    const { basicOptions } = getLightTheme();

    return (
        <div>
            <Toast ref={toast} />
            <Dialog header="分析功能" visible={props.Analysis} modal={false} keepInViewport={false} onHide={() => props.onHide('Analysis')}>
                <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                    <TabPanel header="地形剖面" >
                        <TerrainProfileComponents setTerrainProfileOpen={setTerrainProfileOpen} setTerrainProfileValue={setTerrainProfileValue} />
                    </TabPanel>
                    <TabPanel header="模型切割" >
                        <SliceSpaceComponents setIsSliceSpace={setIsSliceSpace} isSliceSpace={isSliceSpace} />
                    </TabPanel>
                    <TabPanel header="視域分析" >
                        <ViewshedAnalysisComponents ViewshedAnalysisSetting={ViewshedAnalysisSetting} setViewshedAnalysisSetting={setViewshedAnalysisSetting} />
                    </TabPanel>
                </TabView>
                <Dialog header="地形剖面結果" visible={TerrainProfileOpen} modal={false} keepInViewport={false} onHide={() => setTerrainProfileOpen(false)} style={{ width: "50vw" }}>
                    <Chart type="line" data={TerrainProfileValue} options={basicOptions} height="60vh" />
                </Dialog>
            </Dialog>
        </div>
    );
}